import { useState, useEffect } from "react";
import api from '../config/api';

export default function EditVillaModal({ show, onClose, onSuccess, villa }) {
  const [form, setForm] = useState({
    name: "",
    location: "",
    description: "",
    is_active: true,
  });
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (villa) {
      setForm({
        name: villa.name || "",
        location: villa.location || "",
        description: villa.description || "",
        is_active: villa.is_active,
      });
    }
  }, [villa]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    const user_id = JSON.parse(atob(token.split(".")[1])).user_id;

    const payload = {
      ...form,
      created_by: villa.created_by,
      modified_by: user_id,
    };

    try {
      const response = await fetch(api(`/villas/${villa.id}`), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const err = await response.json();
        setErrorMessage(err.error || "Failed to update villa");
        return;
      }

      onSuccess();
      onClose();
      setErrorMessage("");
    } catch (err) {
      console.error(err);
      setErrorMessage("Something went wrong.");
    }
  };

  if (!show || !villa) return null;

  return (
    <div className="modal fade-modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Villa</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  className="form-control"
                  name="location"
                  value={form.location}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  rows={3}
                />
              </div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="is_active"
                  checked={form.is_active}
                  onChange={handleChange}
                  id="activeCheckEdit"
                />
                <label className="form-check-label" htmlFor="activeCheckEdit">
                  Active
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" type="button" onClick={onClose}>
                Cancel
              </button>
              <button className="btn btn-primary" type="submit">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
